import { Component } from '@angular/core';
import { IonContent, IonHeader, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { ButtonComponent, LogoComponent } from '@work-frontend-monorepo/work-ui/layout';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'sfg-app-global-start-ueber-uns-tab',
  templateUrl: './global-start-ueber-uns-tab.component.html',
  standalone: true,
  imports: [IonContent, IonHeader, IonTitle, IonToolbar, ButtonComponent, LogoComponent, TranslatePipe],
})
export class GlobalStartUeberUnsTabComponent {
  protected call() {
    window.open('tel:+41767669646', '_system');
  }

  protected mail() {
    window.open('mailto:info@sfg-ag.ch', '_system');
  }
}
